var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForImmediateTreatment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.03 22.177c0 6.584-5.337 11.92-11.921 11.92-6.583 0-11.92-5.336-11.92-11.92s5.337-11.921 11.92-11.921c6.584 0 11.921 5.337 11.921 11.92z",
    stroke: "#040B44",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FE5050",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.109 16.58v6.188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.676 26.818a1.567 1.567 0 1 1-3.134 0 1.567 1.567 0 0 1 3.134 0",
    fill: "#FE5050"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#040B44",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.868 5.5h6.482M20.109 5.5v4.291M32.219 12.883l-2.018-2.018M8 12.883l2.018-2.018"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForImmediateTreatment);
export default __webpack_public_path__ + "static/media/forImmediateTreatment.79419a097e8aa1b36625864a9f6748f2.svg";
export { ForwardRef as ReactComponent };